import { EffectiveDateExposureAndLapseForm } from "@covertree/new-business-forms";
import {
  selectUnitCount,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { FormSelectableWithValue } from "@covertree/types";
import { FormRadioGroup } from "@covertree/ui";
import { useMemo } from "react";
import { useForm } from "react-hook-form";

const unitCounts = (): FormSelectableWithValue<string>[] => {
  return [
    {
      title: "Single unit",
      value: "single-unit",
      image: "/images/card-icons/landlord.webp",
      imageAlt: "Single house",
    },
    {
      title: "Multi-unit",
      value: "multi-unit",
      image: "/images/card-icons/landlord-multi-unit.webp",
      imageAlt: "Many houses",
      subtitle: "Coming Soon",
      disabled: true,
    },
  ];
};

interface Props {
  readonly onOptionSelect?: (option: unknown) => void;
}

export function UnitCountRadioGroup({ onOptionSelect }: Props) {
  const unitCount = useNewBusinessSelector(selectUnitCount);
  const { control, watch } = useForm<EffectiveDateExposureAndLapseForm>({
    defaultValues: {
      unitCount,
    },
    shouldUnregister: true,
  });

  const selected = watch("unitCount");

  const items = useMemo(() => {
    return unitCounts();
  }, []);

  return (
    <FormRadioGroup
      name="unitCount"
      control={control}
      selected={selected}
      label={"How many units are on this policy?"}
      items={items}
      direction="column"
      onOptionSelect={onOptionSelect}
    />
  );
}
